<template>
    <div class="filtro-content">
        <i class="fas fa-filter filter-icon color-blue"></i>

        <el-button-group class="switch-tipo d-inline-block">
            <el-button @click="clickTipo(true)" size="small" :class="{ selected: filtros.selectedGroup }">Cluster</el-button>
            <el-button @click="clickTipo(false)" size="small" :class="{ selected: !filtros.selectedGroup }">Grupo</el-button>
        </el-button-group>
       
        <el-select v-if="getWidth >= 950 && filtros.selectedGroup === true" filterable clearable class="d-inline-block" size="small" v-model="filtros.tipo" placeholder="Selecione o Cluster">
            <el-option
            v-for="item in optionsCluster"
            :key="item.id"
            :label="item.label"
            :value="item.id">
            </el-option>
        </el-select>


        <el-select v-if="getWidth >= 950 && filtros.selectedGroup === false" filterable clearable class="d-inline-block" size="small" v-model="filtros.tipo" placeholder="Selecione o Grupo">
            <el-option
            v-for="item in optionsGrupo"
            :key="item.id"
            :label="item.label"
            :value="item.id">
            </el-option>
        </el-select>

        <el-date-picker
            v-if="getWidth >= 950"
            class="pull-right"
            size="small"
            ref="daterangepicker"
            v-model="filtros.datas"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="-"
            start-placeholder="Início"
            end-placeholder="Fim"
            :picker-options="pickerOptions"
            format="MM/yyyy"
            @click.native="clickOnDatepicker">
        </el-date-picker>


        <el-drawer
            title="Filtros"
            :visible.sync="drawer"
            direction="rtl"
            ref="drawer"
            custom-class="filtro-drawer">
            <b-row class="filtro-drawer-body">
                <b-col>
                    <b-form>
                        <b-form-group :label="`Selecione o ${modelFiltros.selectedGroup ? 'Cluster' : 'Grupo'}`">
                            <el-select style="width: 100%;" v-if="modelFiltros.selectedGroup" class="d-inline-block" size="small" filterable clearable v-model="modelFiltros.tipo" placeholder="Selecione o Cluster">
                                <el-option
                                v-for="item in optionsCluster"
                                :key="item.value"
                                :label="item.label"
                                :value="item.id">
                                </el-option>
                            </el-select>


                            <el-select style="width: 100%;" v-if="!modelFiltros.selectedGroup" class="d-inline-block" size="small" filterable clearable v-model="modelFiltros.tipo" placeholder="Selecione o Grupo">
                                <el-option
                                v-for="item in optionsGrupo"
                                :key="item.value"
                                :label="item.label"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </b-form-group>

                        <b-form-group label="Data">
                            <el-date-picker
                                size="small"
                                ref="daterangepickermobile"
                                v-model="modelFiltros.datas"
                                type="monthrange"
                                align="right"
                                unlink-panels
                                range-separator="-"
                                start-placeholder="Início"
                                end-placeholder="Fim"
                                :picker-options="pickerOptions"
                                format="MM/yyyy"
                                @click.native="clickOnDatepicker">
                            </el-date-picker>
                        </b-form-group>
                        
                    </b-form>
                </b-col>
            </b-row>

            <b-row class="filtro-drawer-footer">
                <b-col>
                    <el-button size="small" @click="fecharFiltros">Fechar</el-button>
                    <el-button size="small" type="primary" @click="aplicarFiltros">Aplicar</el-button> 
                </b-col>
            </b-row>

        </el-drawer>
        <el-button v-if="getWidth < 950" size="small" class="pull-right"  @click="drawer = true" plain>Filtros</el-button>
    </div>
</template>
 
 <script>
 import Moment from 'moment';

 const filtrosModel = () => {
    return {
        selectedGroup: true,
        tipo: '',
        grupo: '',
        datas: [],
        shortcut: ''
    }
 };

let dateFromPick = null;

export default {
    name: 'Filtro',
    data() {
        const dt = {
            drawer: false,
            getWidth: window.innerWidth,
            modelFiltros: filtrosModel(),
            optionsCluster: [],
            optionsGrupo: [],
            pickerOptions: {
                disabledDate(time) {
                    if(!dateFromPick){
                        return false
                    }

                    let t = Moment(new Date(dateFromPick)).subtract(11, 'M').startOf('month');
                    let t2 = Moment(new Date(dateFromPick)).add(11, 'M').endOf('month');

                    return !Moment(time).isBetween(t, t2);
                },
                onPick(objDates){
                    if(objDates.minDate || objDates.maxDate){
                        dateFromPick = objDates.minDate || objDates.maxDate
                    }
                }
            },
        }
        return dt;
    },
    methods: {
        fecharFiltros() {
            this.modelFiltros = filtrosModel();
            this.drawer = false;
        },
        aplicarFiltros() {
            this.drawer = false;
            this.filtros = this.modelFiltros;
            this.trackingF360(this, 'Home','Filtros');
        },
        async getListas(optModel, route) {
            let response = await this.axios.get(route);

            if(response.status !== 200) {
                return;
            }

            this.$data[optModel] = response.data;
        },
        clickTipo(valor){
            this.filtros.tipo = '';
            this.filtros.selectedGroup = valor;

            this.trackingF360(this, 'Home', `Filtro ${valor ? 'Cluster' : 'Grupo'}`);
        },
        clickOnDatepicker() {
            dateFromPick = null;

            if(this.getWidth <= 700){
                document.querySelector('.el-picker-panel__icon-btn.el-icon-d-arrow-right.is-disabled').removeAttribute('disabled');
            }
        }
    },
    computed: {
		filtros: {
            get() {
                return this.$store.state.filtros;
            },
            set(value) {
                this.$store.commit('updateFiltros', value);
            }
        }
	},
    watch: {
        filtros: {
            deep: true,
            handler(val){
                if(this.drawer) {
                    return;
                }

                //seta storage de filtros
                /* let getUser = JSON.parse(localStorage.getItem('user')) || {}
                localStorage.setItem('f360-filtros' + getUser.customer.nome,JSON.stringify(val)); */
                this.filtros = val;
                this.trackingF360(this, 'Home', 'Filtros');
            }
        },
        /* 'filtros.selectedGroup'(val) {
            let getUser = JSON.parse(localStorage.getItem('user')) || {}

            let loadFiltros = JSON.parse(localStorage.getItem('f360-filtros' + getUser.customer.nome));
            if(loadFiltros.selectedGroup !== val){
                this.filtros.tipo = '';
            }
        }, */
        'filtros.datas'() {
            dateFromPick = null;
        }
    },
    mounted() {
        // init daterange para esse mês
        const date = new Date();
        const end = new Date(date.getFullYear(), date.getMonth(), 0);
        const start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        
        this.filtros.datas = [start,end];

        this.getListas('optionsCluster', this.$urls.CLUSTERS);
        this.getListas('optionsGrupo', this.$urls.GRUPOS);

        let getUser = JSON.parse(localStorage.getItem('user')) || {}

        let loadFiltros = JSON.parse(localStorage.getItem('f360-filtros' + getUser.customer.nome));
        if(loadFiltros) {
            this.filtros = loadFiltros
            if(!loadFiltros.tipo){
                loadFiltros.grupo = '';
            }
        }

        window.addEventListener('resize', () => {
            this.getWidth = window.innerWidth;
        });
    }
 }
 </script>
 
 <style lang="scss">
    .c-affix.is-fixed {
        z-index: 2010 !important;
    }
    .filtro-content {
        .filter-icon {
            position: absolute;
            left: 12px;
            top: 12px;
        }
        .switch-tipo {
            margin: 0 15px 0 35px;
            .el-button {
                border-radius: 10px;
                &.selected {
                    background: #16223D !important;
                    color:#fff;
                }
            }
        }
        .el-popover {
            .el-select .el-input {
                width: 100%;
            }
        }
        .el-drawer.rtl {
            min-width: 360px !important;
        }
        .filtro-drawer-body {
            margin: 0 6px;
        }
        .filtro-drawer-footer {
            margin: 24px 6px 0;
        }
        .el-date-editor.el-range-editor {
            @media (max-width: 960px) {
                width: 100%;
            }
        }
        .select-grupos {
            width: 100%;
            .el-input--suffix {
                width: 100%;
            }
        }
    }
    .el-picker-panel__shortcut {
        font-size: 12px !important;
        &.selected {
            background: #44a0ff;
            color: #fff;
        }
    }
    @media (max-width: 700px) {
        .el-picker-panel__content.el-date-range-picker__content.is-right {
            display:none;
        }
        .el-date-range-picker__content {
            width: 100% !important;
        }
    }
    @media screen and (max-width: 600px){
        .el-date-range-picker .el-picker-panel__body {
            min-width: auto;
            max-width: 400px;
        }
        .el-date-range-picker__content {
            margin-left: 12% !important;
            width: 58% !important;
        }
    }
    @media screen and (max-width: 400px){
        .el-date-range-picker__content {
            margin-left: 5% !important;
        }
    }
 </style>
